import {
  GET_PROFILE_REQUESTING,
  GET_PROFILE_REQUEST_SUCCESS,
  BANK_ACC_REQUESTING,
  BANK_ACC_REQUEST_SUCCESS,
  BANK_ACC_REQUEST_ERROR,
  GET_PROFILE_REQUEST_ERROR,
  SET_DEFAULT_REQUESTING,
  SET_DEFAULT_REQUEST_SUCCESS,
  SET_DEFAULT_REQUEST_ERROR,
} from './constants';

const initialState = {
  profile: null,
  profileRequesting: false,
  profileErrors: [],

  bankAcc: null,
  bankAccRequesting: false,
  bankAccErrors: [],

  setDefaultSuccess: false,
  setDefaultErrors: [],
};

const reducer = function customerReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PROFILE_REQUESTING:
      return {
        ...state,
        profile: null,
        profileRequesting: true,
        profileErrors: [],
      };

    case GET_PROFILE_REQUEST_SUCCESS:
      return {
        ...state,
        profile: action.data,
        profileRequesting: false,
        profileErrors: [],
      };

    case GET_PROFILE_REQUEST_ERROR:
      return {
        ...state,
        profile: null,
        profileRequesting: false,
        profileErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case BANK_ACC_REQUESTING:
      return {
        ...state,
        bankAcc: null,
        bankAccRequesting: true,
        bankAccErrors: [],
      };

    case BANK_ACC_REQUEST_SUCCESS:
      return {
        ...state,
        bankAcc: action.data,
        bankAccRequesting: false,
        bankAccErrors: [],
      };

    case BANK_ACC_REQUEST_ERROR:
      return {
        ...state,
        bankAcc: null,
        bankAccRequesting: false,
        bankAccErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    case SET_DEFAULT_REQUESTING:
      return {
        ...state,
        setDefaultSuccess: false,
        setDefaultErrors: [],
      };

    case SET_DEFAULT_REQUEST_SUCCESS:
      return {
        ...state,
        setDefaultSuccess: true,
        setDefaultErrors: [],
      };

    case SET_DEFAULT_REQUEST_ERROR:
      return {
        ...state,
        setDefaultSuccess: false,
        setDefaultErrors: [
          ...[
            {
              body: action.error.toString(),
              time: new Date(),
            },
          ],
        ],
      };

    default:
      return state;
  }
};

export default reducer;
